<template>
    <v-dialog
        v-model="value"
        fullscreen
        content-class="grey lighten-5 dialog-lg flex-dialog calculator-add-treatment-dialog"
        persistent
        transition="dialog-bottom-transition"
        :overlay="false"
    >
        <v-toolbar dark style="flex-grow: 0; width: 100%; background: rgb(150, 150, 160); box-shadow: inset 0 5px 5px rgba(255,255,255,.1);" height="52">
            <div style="text-align: center; width: 100%; font-size: 17px; font-weight: 600;">
                {{ $t('plan_calculator.treatment') }}<span style="font-size: 13px;" v-if="['upper','lower'].includes(activeJaw)">&nbsp;({{ $t('plan_calculator.' + activeJaw).toLowerCase() }})</span>
            </div>
        </v-toolbar>
        <div class="dialog-content" style="position: relative; padding: 0 0 0 0;">
            <div class="grey lighten-4 pm-simple-plan--overview-header" style="box-shadow: 0 0 10px rgba(0,0,0,.08); position: relative; z-index: 2;">
                <div class="white text-xs-center" style="margin-top: 0px; padding: 15px 0 20px 0;">
                    <div>
                        <pm-price class="roboto calculator-total-price" style="font-weight: 600; font-size: 20px;" :currency="currency" :value="total" />
                    </div>
                </div>
            </div>
            <div class="white" style="position: absolute; top: 66px; bottom: 0px; left: 0; right: 0; overflow-y: auto; box-shadow: 0 8px 15px rgba(0,0,0,.03);">
                <template v-for="(group, i) in groupedItems" v-if="group && group.length > 0">
                    <div style="display: flex; padding: 8px 16px; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);" class="grey lighten-5 extra-treatment-header">
                        <span class="overview--sub-title roboto f13 bold--text">{{ $t('plan_calculator.group_' + i) }}</span>
                        <div style="flex-grow: 1" />
                    </div>

                    <div v-for="(state, n) in group" :key="n" v-if="n<300">
                        <pm-step-stepper
                            :value="typeof extraStepAmounts[state.id] !=='undefined' ? extraStepAmounts[state.id] : 0"
                            show-price
                            :unit-price="$store.getters['smart/priceOfTreatment'](state.id, $store.state.currency)"
                            :step="1"
                            :title="$store.getters['smart/titleOfTreatment'](state.id, $store.state.language, false)"
                            :max=99
                            :min=0
                            @input="(v) => updateExtra(state.id, v)"
                        />
                    </div>
                </template>
                <br>
            </div>
        </div>
        <div class="text-xs-center dialog-footer white" style="position: relative; z-index: 2; height: 72px; display: flex; align-items: center; justify-content: center; padding: 0; box-shadow: 0 -15px 30px rgba(255,255,255,1);">
            <v-btn flat style="min-width: auto;" class="app-back-button-icon" @click="addSelectedExtraSteps">
                <v-icon style="color: #000!important;" >check</v-icon>
            </v-btn>
        </div>
    </v-dialog>
</template>

<style>
 .calculator-add-treatment-dialog {
     max-width: Calc(100vw - 20px);
     max-height: Calc(100vh - 20px);
     margin: 10px;
     border-radius: 10px;
     box-shadow: 0 0 20px rgba(0,0,0,.3);
 }

@media (min-width: 700px) {
    .pm-simple-plan--overview-header .white.text-xs-center {
        padding: 15px 0 15px 0 !important;
    }

    .calculator-add-treatment-dialog {
        /* width: 80vw; */
        position: relative;
    }

    .extra-treatment-header {
        padding: 10px 36px !important;
    }

    .calculator-add-treatment-dialog .calculator-total-price {
        /* */
    }

    .calculator-add-treatment-dialog .overview--sub-title {
        font-size: 16px;
    }

    .calculator-add-treatment-dialog .step-stepper--title {
        font-size: 18px;
    }

    .calculator-add-treatment-dialog .step-stepper--price {
        font-size: 15px !important;
    }

    .calculator-add-treatment-dialog .step-stepper--counter {
        font-size: 20px;
    }

    .calculator-add-treatment-dialog .step-stepper--button-decrease {
        font-size: 32px !important;
        width: 44px !important;
        height: 44px !important;
        line-height: 36px!important;
        display: inline-block !important;
        text-align: center;
    }

    .calculator-add-treatment-dialog .step-stepper--button-increase {
        font-size: 32px !important;
        width: 44px !important;
        height: 44px !important;
        line-height: 40px!important;
        display: inline-block !important;
        text-align: center;
    }
}
</style>

<script>
import PmStepStepper from "./step-stepper";
export default {
    components: {PmStepStepper},
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        steps: {
            type: Object,
        },
        activeJaw: {
            type: String,
        }
    },

    data: function() {
        return ({
            selectedJaw: "none",
            extraStepAmounts: {},
            updated: 0,
            groupedItems: [],
            total: 0,
            currency: this.$store.state.currency,
        });
    },

    created() {
        this.groupedItems = this.$store.getters["smart/groupedTreatments"](false);
    },

    watch: {
        value() {
            this.extraStepAmounts = {};
            this.total = 0;

            if(this.value && this.steps) {
                Object.keys(this.steps).forEach(key => {
                    this.$set(this.extraStepAmounts, String(key), this.steps[key]);
                });
                this.calculateTotal();
            }
        },
    },

    methods: {
        calculateTotal() {
            this.total = 0;
            Object.keys(this.extraStepAmounts).forEach((stateId) => {
                if (this.extraStepAmounts[String(stateId)] <= 0) return;
                const amount = this.extraStepAmounts[String(stateId)];
                const unitPrice = this.$store.getters["smart/priceOfTreatment"](stateId, this.$store.state.currency);
                this.total += amount * unitPrice;
            });
        },

        updateExtra(id, val) {
            if (typeof this.extraStepAmounts[String(id)] === "undefined") this.$set(this.extraStepAmounts, String(id), 0);
            this.$set(this.extraStepAmounts, String(id), val);
            this.calculateTotal();
        },

        addSelectedExtraSteps() {
            this.$emit("select", JSON.parse(JSON.stringify(this.extraStepAmounts)));
            this.$emit("input", false);
        },
    },
};
</script>
